<script lang="ts">
  import { onMount } from "svelte"
  import { Layout } from "../../components";
  import { cancelJob, deleteJob, getJob, rerunJob, reuploadJob } from "../../services/endpoints"
  import { _ } from "svelte-i18n"
  import { Code, Button } from "@gl/design-system"
  import { navigateCustom } from "../../utils/navigateCustom"

  let job;
  export let uuid;

  onMount(() => {
    getJob(uuid).then(j => job = j)
  })

  function reupload() {
    reuploadJob(uuid)
  }

  function rerun() {
    rerunJob(uuid)
  }

  function cancel() {
    cancelJob(uui)
  }

  function _deleteJob() {
    deleteJob(uuid).then(() => navigateCustom("/jobs"))
  }
</script>

<Layout selected="jobs">
  <h1>{$_("common.job")}</h1>
  <Button on:click={reupload}>{$_("common.reupload")}</Button>
  <Button on:click={rerun}>{$_("common.rerun")}</Button>
  <Button on:click={cancel} status="warning">{$_("common.cancel")}</Button>
  <Button on:click={_deleteJob} status="error">{$_("common.delete")}</Button>
  {#if job}
  <Code>
    {JSON.stringify(job, null, 2)}
  </Code>
  {/if}
</Layout>